import vet1 from "../images/vet2/문종선.png";
import vet2 from "../images/vet2/정다슬.png";
import vet3 from "../images/vet2/김도희.png";
import vet4 from "../images/vet2/남채민.png";
import vet5 from "../images/vet2/박설기.png";
import vet6 from "../images/vet2/박주향.png";
import vet7 from "../images/vet2/최아름.png";
import vet8 from "../images/vet2/정태규.png";
import vet9 from "../images/vet2/윤기홍.png";
import vet10 from "../images/vet2/이선백.png";
import vet11 from "../images/vet2/최신영.png";
import vet12 from "../images/vet2/서율지.png";
import vet13 from "../images/vet2/박성은.png";
import vet14 from "../images/vet2/이한중.png";
import vet15 from "../images/vet2/doc_152.png";
import vet16 from "../images/vet2/doc_162.png";
import vet17 from "../images/vet2/doc_172.png";
import vet18 from "../images/vet2/doc_182.png";
import vet19 from "../images/vet2/doc_192.png";

import tvet1 from "../images/vet/문종선.png";
import tvet2 from "../images/vet/정다슬.png";
import tvet3 from "../images/vet/김도희.png";
import tvet4 from "../images/vet/남채민.png";
import tvet5 from "../images/vet/박설기.png";
import tvet6 from "../images/vet/박주향.png";
import tvet7 from "../images/vet/최아름.png";
import tvet8 from "../images/vet/정태규.png";
import tvet9 from "../images/vet/윤기홍.png";
import tvet10 from "../images/vet/이선백.png";
import tvet11 from "../images/vet/최신영.png";
import tvet12 from "../images/vet/서율지.png";
import tvet13 from "../images/vet/박성은.png";
import tvet14 from "../images/vet/이한중.png";
import tvet15 from "../images/vet/doc_151.png";
import tvet16 from "../images/vet/doc_161.png";
import tvet17 from "../images/vet/doc_171.png";
import tvet18 from "../images/vet/doc_181.png";
import tvet19 from "../images/vet/doc_191.png";
// 순서: 문종선 정다슬 박설기 김도희 최동준 이한중 박주향 남채민 정태규 최아름 윤기홍 이선백 최신영
const vetInfo = [
  {
    id: 1,
    position: "대표원장",
    name: "문종선",
    img: vet1,
    timg: tvet1,
    title: "전북대학교 수의학과",
    greetings:
      "치료는 아픈 아이들의 마음을 이해하는 것부터 시작입니다. 보호자님들과 아이들이 함께하는 시간의 시작과 끝을 책임지겠습니다.",
    history: [
      "전북대학교 수의과대학 수의학과 졸업",
      "이천시청,성남시청 공중방역수의사",
      "우리아이동물메디컬센터진료수의사",
      "부천SKY동물메디컬센터 진료수의사",
      "서울 신사SKY동물메디컬센터 선임 진료수의사",
      "서울 신사SKY동물메디컬센터 진료과장",
      "전)인천SKY동물의료센터 부원장",
      "전)계양SKY동물의료센터 원장",
      "현)인천SKY동물메디컬센터 원장",
      "한국고양이수의사회 정회원",
    ],
    paper: [],
    completion: ["CVA(미국수의한방침치료과정인증) 수료"],
  },
//   {
//     id: 2,
//     position: "부원장",
//     name: "정다슬",
//     img: vet2,
//     timg: tvet2,
//     title: "건국대학교 수의학과",
//     greetings: "모든 동물들이 건강하고 행복하도록 최선을 다하겠습니다.",
//     history: [
//       "건국대학교 수의과대학 수의학과 졸업",
//       "수원SKY동물메디컬센터 진료수의사",
//       "인천SKY동물메디컬센터 진료수의사",
//       "인천SKY동물메디컬센터 진료과장",
//       "현)인천SKY동물메디컬센터 부원장",
//     ],
//     paper: [],
//     completion: [],
//   },
  {
    id: 5,
    position: "원장",
    name: "박설기",
    img: vet5,
    timg: tvet5,
    title: "서울대학교 수의과대학 석사",
    greetings:
      "아이들을 제 가족처럼 소중히 여기며 감동과 희망을 전하는 수의사가 되겠습니다.",
    history: [
      "경상대학교 수의학과 학사 졸업",
      "서울대학교 수의과대학 부속 동물병원 수련과정 수료",
      "서울대학교 수의과대학 내과학교실 실습조교",
      "서울대학교 수의과대학 수의내과학 석사 졸업",
      "우리동물메디컬센터 내과과장",
      "2018.05 한국임상수의학회 춘계학술대회 구두발표",
      "2019.06 ISSCR in LA 참가",
      "2019.09 FASAVA in tokyo 참가",
    ],
    paper: [
      "Pretreatment with IFN-γ enhances the immunomodulatory effect of feline adipose tissue-derived mesenchymal stem cells through the COX-2/PGE2 pathway",
      "Case of babesiosis induced thrombocytopenia in a dog.",
      "Clinical application of both amniotic membranes and adipose derived mesenchymal stem cells in a cat with large skin defect",
    ],
    completion: [
      "2019 해마루 심장초음파 wet lab 수료",
      "2020 수의한방 침술사 자격증(CVA) 취득",
    ],
  },
  {
    id: 3,
    position: "외과과장",
    name: "김도희",
    img: vet3,
    timg: tvet3,
    title: "건국대학교 수의외과학 석박사통합과정 수료",
    greetings: "반려동물과 함께하는 가족의 행복을 위해 늘 함께 하겠습니다.",
    history: [
      "건국대학교 수의과대학 수의학과 졸업",
      "건국대학교 수의과대학 수의외과학 석박사통합과정 수료",
      "건국대학교 수의과대학 부속동물병원 진료수의사",
      "건국대학교 수의과대학 외과실습 조교",
      "현)인천SKY동물메디컬센터 외과과장",
    ],
    paper: [],
    completion: [],
  },

  {
    id: 14,
    position: "외과과장",
    name: "이한중",
    img: vet14,
    timg: tvet14,
    title: "충남대학교 임상수의학 석사",
    greetings: "환자와 보호자님의 삶에 행복을 드릴 수 있도록 헌신하겠습니다.",
    history: [
      "전북대학교 수의학과 졸업",
      "충남대학교 임상수의학 석사 졸업",
      "전) VIP동물의료센터 동대문점 외과 팀장",
      "현) 인천SKY동물메디컬센터 외과 과장",
    ],
    paper: [
      'Lee, Hanjung, et al. "Epineural Neurorrhaphy of a Large Nerve Defect Due to IatroGenic Sciatic Nerve Injury in a Maltese Dog." Veterinary Sciences 9.7 (2022): 361.',
    ],
    completion: [],
  },
//   {
//     id: 6,
//     position: "영상의학과장",
//     name: "박주향",
//     img: vet6,
//     timg: tvet6,
//     title: "경북대학교 수의과대학 석사",
//     greetings: "다정한 손길로, 숨은 질환도 꼼꼼하게 찾아내도록 하겠습니다.",
//     history: [
//       "경북대학교 수의과대학 수의과대학 졸업",
//       "경북대학교 수의과대학 대학원 석사 졸업 (수의영상의학 전공)",
//       "경북대학교 부속동물병원 수련수의사",
//       "경북대학교 수의과대학 수의영상의학 조교",
//       "대구광역시 초등학교 동물보호교육 강사",
//       "현) 인천스카이동물의료센터 영상과장",
//     ],
//     paper: [
//       "Diagnosis of mammary carcinoma in a castrated male Maltese dog. Journal of Veterinary Clinics (2019)",
//     ],
//     completion: [
//       "2018 미국 텍사스 International Veterinary Radiology Association 참가 및 포스터 발표",
//       "2018-2019 서울시수의사회 학술지 VETIS 연재",
//       "2018-2019 한국임상수의학회 참석",
//       "2019 한국수의영상의학연구회 참가 및 feline alimentary lymphoma case 구두 발표",
//       "2019 미국 아리조나 American College of Veterinary Internal Medicine Forum 참석",
//     ],
//   },
  {
    id: 4,
    position: "영상의학과장",
    name: "남채민",
    img: vet4,
    timg: tvet4,
    title: "건국대학교 수의과대학 수의영상의학 전공 석사 졸업",
    greetings: "환자와 보호자를 위해 늘 최선을 다하겠습니다.",
    history: [
      "건국대학교 수의과대학 졸업",
      "건국대학교 수의과대학 부속동물병원 수련 수의사",
      "건국대학교 수의과대학 수의영상의학 실습 조교",
      "건국대학교 수의과대학 수의영상의학 전공 석사 졸업",
      "전) 스탠다드동물의료센터 영상의학수의사",
      "현) 인천SKY동물메디컬센터 영상의학과장",
    ],
    paper: [],
    completion: [
      "2024   춘계 한국임상수의학회 구두발표 및 우수학술발표상 “Computed Tomographic and Ultrasonographic Imaging Features for Differentiation of Canine Intestinal Mast Cell Tumors Compared with Alimentary Lymphoma”",
      "2024   Nam C, Park N, Shin M, Lim H, Kim J, Eom K. Sonographic and computed tomographic features of intestinal mast cell tumors m",
    ],
  },
  {
    id: 16,
    position: "영상의학과장",
    name: "최정인",
    img: vet16,
    timg: tvet16,
    title: "충남대학교 수의과대학 수의영상의학 전공 석사 졸업",
    greetings: "환자와 보호자님의 마음까지 치료하는 수의사가 되겠습니다",
    history: [
      "충남대학교 수의과대학 수의학과 졸업",
      "충남대학교 수의과대학 수의영상의학 전공 석사 졸업",
      "충남대학교 수의과대학 수의영상의학 실습 조교",
      "충남대학교 부속동물병원 영상의학과 진료수의사",
      "SK telecom AI 기반 수의영상진단 솔루션 개발 사업 참여 연구원",
      "현) 인천SKY동물메디컬센터 영상의학과장",
    ],
    paper: [],
    completion: [
      "2022 한국임상수의학회 춘계학술대회 포스터 발표 [Echocardiographic findings of left atrial thrombus in a dog]",
      "2023 한국임상수의학회 추계학술대회 구두 발표 [Tetralogy of Fallot with suspected subaortic stenosis in a dog]",
    ],
  },
  {
    id: 8,
    position: "응급의학과장",
    name: "정태규",
    img: vet8,
    timg: tvet8,
    title: "서울대학교 임상수의학 응급의학과 석사",
    greetings:
      "모든 환자들은 특별하고 소중합니다. 아이들의 건강을 위해 헌신하겠습니다.",
    history: [
      "서울대학교 수의과대학 수의학과 졸업",
      "서울대학교 수의과대학 임상수의학 응급의학과 석사졸업",
      "서울대학교 동물병원 진료수의사",
      "서울대학교 수의학과 수의응급의학과 실습조교",
      "관악구 이로동물병원 진료수의사",
      "수원 24시바른동물의료센터 응급의학과장",
      "현)인천SKY동물메디컬센터 응급의학과장",
    ],
    paper: [],
    completion: ["CVA(미국수의한방침치료인증) 수료"],
  },
  {
    id: 7,
    position: "응급의학과장",
    name: "최아름",
    img: vet7,
    timg: tvet7,
    title: "서울대학교 수의과대학 임상수의학 응급의학과 석사 졸업",
    greetings: "생사의 길목에 서 있는 환자를 위해 항상 최선을 다하고 있습니다",
    history: [
      "서울대학교 수의과대학 수의학과 졸업",
      "서울대학교 동물병원 응급실 수의사",
      "서울대학교 수의과대학 응급의학과 실습 조교",
      "서울대학교 수의과대학 임상수의학 응급의학과 석사 졸업",
      "현) 인천SKY동물메디컬센터 응급의학과장",
    ],
    paper: [],
    completion: [
      "2021 한국임상수의학회 (추계) 발표",
      "2023 Chi university Asia conference 발표",
      "2023 서울대학교 ERD day 우수포스터 발표상 발표 및 수상",
      "2024 국제 수의 응급의학 학회 IVECCS 포스터 발표",
      "CVA(미국수의한방침치료과정) 취득",
    ],
  },
  {
    id: 9,
    position: "응급의학팀장",
    name: "윤기홍",
    img: vet9,
    timg: tvet9,
    title: "경상대학교 수의과 대학 졸업",
    greetings: "보호자님의 마음까지 공감할 수 있는 수의사가 되겠습니다.",
    history: [
      "경상대학교 수의학과 졸업",
      "전) ㈜크로넥스 CRO팀 책임수의사",
      "전) 대전성심동물메디컬센터 진료수의사",
      "전) 인천SKY동물메디컬센터 진료수의사",
      "현) 인천SKY동물메디컬센터 응급의학팀장",
    ],
    paper: [],
    completion: [],
  },
  {
    id: 15,
    position: "치과센터장",
    name: "윤한병",
    img: vet15,
    timg: tvet15,
    title: "경북대학교 수의과대학 수의외과학 석사",
    greetings: "치과는 통증을 관리하여 아이의 건강하고 행복한 삶을 도와줍니다",
    history: [
        "경북대학교 수의과대학 수의학과 졸업",
        "경북대학교 수의외과학 석사 졸업",
        "경북대학교 수의외과학 박사 과정",
        "로얄펫동물병원 부원장",
        "한빛동물병원 원장",
        "보듬동물병원 원장",
        "현)인천SKY동물메디컬센터 치과센터장",
        "현)청담VIP동물메디컬센터 치과과장",
    ],
    paper: [],
    completion: [
    //   "충남대학교 동물병원 임상 로테이션 수료",
    //   "충남대학교 수의과대학 병리학 실험실 심화 과정 수료",
    //   "해마루 임상수의학 과정 수료",
    ],
  },
//   {
//     id: 11,
//     position: "진료수의사",
//     name: "최신영",
//     img: vet11,
//     timg: tvet11,
//     title: "경상대학교 수의과대학 졸업",
//     greetings:
//       "아이들의 행복과 건강, 삶의 질을 위해 최선을 다하는 수의사가 되겠습니다.",
//     history: [
//       "경상대학교 수의과대학 졸업",
//       "현) 인천SKY동물메디컬센터 진료수의사",
//     ],
//     paper: [],
//     completion: [
//       "경상대학교 수의과대학 부속동물병원 심화임상실습 수료",
//       "서울대학교 수의과대학 부속동물병원 마취과실습 수료",
//     ],
//   },
  {
    id: 12,
    position: "건강검진센터과장",
    name: "서율지",
    img: vet12,
    timg: tvet12,
    title: "충남대학교 수의과대학 학사 졸업",
    greetings:
      "함께 하는 모든 순간을, 진료부터 치료, 그 끝까지 아이에게 최선을 다하겠습니다.",
    history: [
      "충남대학교 수의과대학 학사 졸업",
      "현) 인천SKY동물메디컬센터 진료수의사",
    ],
    paper: [],
    completion: [
      "충남대학교 동물병원 임상 로테이션 수료",
      "충남대학교 동물병원 내과 심화 과정 수료",
      "충남대학교 수의과대학 병리학 실험실 심화 과정 수료",
      "해마루 임상수의학 과정 수료",
    ],
  },
  {
    id: 13,
    position: "건강검진센터과장",
    name: "박성은",
    img: vet13,
    timg: tvet13,
    title: "충남대학교 수의과대학 학사 졸업",
    greetings: "반려동물의 건강과 보호자님 마음을 위해 최선을 다하겠습니다.",
    history: [
      "충남대학교 수의과대학 학사 졸업",
      "현) 인천SKY동물메디컬센터 진료수의사",
    ],
    paper: [],
    completion: [
      "충남대학교 동물병원 임상 로테이션 수료",
      "충남대학교 수의과대학 병리학 실험실 심화 과정 수료",
      "해마루 임상수의학 과정 수료",
    ],
  },
//   {
//     id: 10,
//     position: "진료수의사",
//     name: "이선백",
//     img: vet10,
//     timg: tvet10,
//     title: "건국대학교 수의과대학",
//     greetings: "아이들을 사랑하는 수의사, 따뜻한 손길로 치료하겠습니다.",
//     history: [
//       "건국대학교 수의과대학 졸업",
//       "경기도북부동물위생연구소 공중방역수의사",
//       "베링거인겔하임 기술지원수의사",
//       "현)인천SKY동물메디컬센터 진료수의사",
//     ],
//     paper: [],
//     completion: [],
//   },
  {
    id: 17,
    position: "진료수의사",
    name: "신다민",
    img: vet17,
    timg: tvet17,
    title: "경상대학교 수의과대학 수의학과 졸업",
    greetings: "언제나 믿고 의지할 수 있는 평생 주치의가 되겠습니다.",
    history: [
        "경상대학교 수의과대학 수의학과 졸업",
        "경상대학교 부속동물병원 심화임상실습 수료",
        "SKY동물의료센터 임상로테이션 수료",
        "Fear free 수료",
        "현) 인천SKY동물메디컬센터 진료수의사",
    ],
    paper: [],
    completion: [
    ],
  },
//   {
//     id: 18,
//     position: "진료수의사",
//     name: "장내인",
//     img: vet18,
//     timg: tvet18,
//     title: "경상대학교 수의과대학 수의학과 졸업",
//     greetings: "소중한 우리아이들의 행복을 위한 든든한 동반자가 되겠습니다.",
//     history: [
//         "경상대학교 수의과대학 수의학과 졸업",
//         "경상대학교 부속동물병원 심화임상실습 수료",
//         "SKY동물의료센터 임상로테이션 수료",
//         "Fear free 수료",
//         "현) 인천SKY동물메디컬센터 진료수의사",
//     ],
//     paper: [],
//     completion: [
//     ],
//   },
//   {
//     id: 19,
//     position: "진료수의사",
//     name: "원영우",
//     img: vet19,
//     timg: tvet19,
//     title: "건국대학교 수의과대학 수의학과 졸업",
//     greetings: "반려동물의 작은 신호까지 놓치지 않는 섬세한 수의사가 되겠습니다.",
//     history: [
//         "건국대학교 수의과대학 수의학과 졸업",
//         "충청북도동물위생시험소 공중방역수의사",
//         "충청북도 수의연구사",
//         "SKY동물의료센터 임상로테이션 수료",
//         "현) 인천SKY동물메디컬센터 진료수의사",
//     ],
//     paper: [],
//     completion: [
//     ],
//   },
];

export default vetInfo;
